import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { COOKIE_KEY_MEMBER_KNOWN } from '../../../constants/cookie';

import { getCoupons } from '../../../services/coupon/selector';

import ListCouponsComponent from '../../coupon/ListCouponsComponent';

class CouponSectionComponent extends React.Component {
    /**
     * On set un cookie pour les membres non loggés, non reconnu et qui n'ont pas deja le cookie COOKIE_KEY_MEMBER_KNOWN
     */
    onClickCoupon() {
        const { isAuthenticated, cookies } = this.props;
        if (!isAuthenticated && !cookies.get(COOKIE_KEY_MEMBER_KNOWN)) {
            cookies.set(COOKIE_KEY_MEMBER_KNOWN, 1, { path: '/' });
        }
    }

    render() {
        const { partnerId, partnerName, isAuthenticated, i18n, coupons } = this.props;
        if (coupons && coupons.length > 0) {
            return (
                <section>
                    <h3>{i18n.page.MERCHANTCARD.DISCOUNT_TITLE}</h3>
                    <ListCouponsComponent
                        coupons={coupons}
                        i18n={i18n}
                        partnerName={partnerName}
                        partnerId={partnerId}
                        isAuthenticated={isAuthenticated}
                        onItemClick={this.onClickCoupon.bind(this)}
                    />
                </section>
            );
        }
        return null;
    }
}

CouponSectionComponent.propTypes = {
    partnerId: PropTypes.string.isRequired,
    partnerName: PropTypes.string.isRequired
};

const mapStoreToProps = (state, ownProps) => ({
    coupons: getCoupons(state, ownProps.partnerId),
    i18n: state.i18n,
    isAuthenticated: state.authentication.isAuthenticated
});

export default connect(mapStoreToProps)(CouponSectionComponent);



// WEBPACK FOOTER //
// ./src/components/pages/merchantcard/CouponSectionComponent.js